import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from "@/components/ScrollToTop";
import PageLoader from "@/components/PageLoader";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import SEO from "@/components/SEO";
import Home from "@/pages/Home";
import Generator from "@/pages/Generator";
import CheckLive from "@/pages/CheckLive";
import CheckStripe from "@/pages/CheckStripe";
import Articles from "@/pages/Articles";
import ArticleDetail from "@/pages/ArticleDetail";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import FAQs from "@/pages/FAQs";
import { Toaster } from "@/components/ui/toaster";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <PageLoader />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gen" element={<Generator />} />
            <Route path="/check-live" element={<CheckLive />} />
            <Route path="/check-stripe" element={<CheckStripe />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/articles/:slug" element={<ArticleDetail />} />
            <Route path="/artigos" element={<Articles />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQs />} />
          </Routes>
          <Footer />
          <CookieBanner />
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
